// import React, { useState } from "react";
import { ReactElement } from "react";

// import { LocalizationProvider } from "@fluent/react";
/*
declare var React: any
declare type ReactElement = {}
*/

type BibliographyLineProps = {
    dictionaryMetadata, // TODO: rename to 'data' already + provide the type
    headword: string,
    isEdition: boolean,
    urlPrefix: string,
}

// TODO: @citation-js/plugin-csl
export function BibliographyLine(
    props: BibliographyLineProps)
{
    // let LocalizationProvider = window["FluentReact"].LocalizationProvider;
    // let Localized = window["FluentReact"].Localized;

    // TODO: switch to this (or just `data`?)
    const dictMeta: IBookContract = props.dictionaryMetadata;
    const data: any = dictMeta;
    const urlPrefix: string = props.urlPrefix;
    const headword: string = props.headword;
    const isEdition: boolean = props.isEdition;

    // NOTE: there's no link at VW1; but (DONE) maybe this one could point to an "about" page
    // Previously, it lead to the list of dictionaries;
    // XXX: The 5 JgSlov parts wouldn't show up with the "Slovník česko-německý" query
    //      but only with an exact, full name/title ("Slovník česko-německý, Díl I., A–J").
    // NOTE: an empty title might mean that an entry didn’t map to a dictionary
    const title: string = props.dictionaryMetadata.title ?? '?';
    // let link = "List?search=" + encodeURIComponent(props.dictionaryMetadata.title);
    let authorsPart = null;
    let link = null;
    let sourceName: ReactElement;

    let authors: string | Array<any> = props.dictionaryMetadata.authors;

    if (Array.isArray(authors)) {
        // DONE: render/format the structured author names
        authors = _formatNames({structuredNames: authors});
    }

    if (authors) {
        // XXX: initials of the authors are abbreviated at VW1 ("Bělič, J. – Kamiš, A. – Kučera, K.")
        authorsPart = <>
            <span>{authors}</span>
            {". "}
        </>;
    }

    const editors = isEdition ? _formatNames({
        structuredNames: data.editors ?? [],
        suffixes: {singular: 'ed.', plural: 'eds.'},
        onlyRespType: 'editor',
    }) : '';

    //  XXX: editions didn’t have a definition for the .bold class and rendered
    //       fine; VW1 used bold for dictionary titles so we’ll stick to that
    //       for a little longer
    let className = isEdition ? null : 'bold';
    let linkingAbbreviation = props.dictionaryMetadata.linkingAbbreviation;

    if (linkingAbbreviation) {
        //  XXX: also, make the text italic in a better way (CSS) than using <em />
        className += ' ' + linkingAbbreviation;
        link = "Text/" + encodeURIComponent(props.dictionaryMetadata.linkingAbbreviation);
    }

    let now = new Date();
    // let today = now.toLocaleDateString('cs'); // "10. 7. 2021", XXX: localize this
    const cited = [
        now.getFullYear(),
        (now.getMonth() + 1).toString().padStart(2, '0'),
        now.getDate().toString().padStart(2, '0'),
    ].join('-');

    if (link) {
        sourceName = <a href={link} target="_blank"><em className={className}>
            {title}
            {/* XXX: separate a "sub-title" from e.g. the JgSlov title ("part 1, A-J") */}
        </em></a>;

    } else {
        // The name won't be green in this case (found with React devtools).
        sourceName = <em className={className}>
            {title}
        </em>;
    }

    const publisherText = dictMeta.publisherText?.trim();
    const publishDate = dictMeta.publishDate;
    const publishPlace = data.publishPlace;

    if (isEdition && !linkingAbbreviation) {
        //  XXX: or even a sourceFileName? (rather not, if possible)
        linkingAbbreviation =
            data.sourcePartAbbreviation ?? data.sourceAbbreviation;
    }

    const url = urlPrefix + (isEdition ? linkingAbbreviation : (headword ?? ''));

    // TODO: <Localized id={props.buttonTextId}> (with a different ID)
    let prefixText = isEdition ? 'Citace' : 'Zdroj';

    // NOTE: could be optional
    if (prefixText)
        prefixText = `${prefixText}: `;

    const prefix = prefixText ? (
        isEdition ? prefixText : <em>{prefixText}</em>
    ) : null;

    // TODO: CSL is better than this home-cooked thing so try to switch
    const renderWhenConditionsApply = (items: any[][]): any[] =>
    {
        return items.filter((itemAndCondition) =>
        {
            // if (!Array.isArray(itemAndCondition))
            //     return true;

            let [item, condition] = itemAndCondition;

            return condition === null ? item : condition;

        }).map(itemAndCondition =>
            itemAndCondition[0]
        );
    }

    return <>{/*<LocalizationProvider l10n={props.l10n}>*/}
        {prefix}

        {authorsPart}

        {sourceName}
        {_addFullStop(title)}
        {' '}

        <span>Online. </span>

        {
            editors ?
            `${editors}. ` :
            ''
        }

        {/* TODO: construct parts first and then join using a separator to be
                  able to avoid a doubled full stop (when publishDate is null)
        */}
        {/* if not wrapped in a span, React devtools (in Firefox) wouldn't outline/highlight the whole component */}
        <span>

        {renderWhenConditionsApply([
            [publishPlace, null],
            [': ', Boolean(publishPlace && publisherText)], // in C etc.: !!(expr)

            [publisherText, null],
            [', ', Boolean(publisherText && publishDate)],

            [publishDate, null],
            ['. ', Boolean(publishPlace && publisherText && publishDate)],
        ])}

        {/* XXX: the "OVJ" string is not present in a naked/standalone form in dictionaryMetadata, only as a part of biblText;
                 perhaps publisherText ("ÚJČ") should contain it instead */}
        {/* publisherText}{publishDate ? ", " : "" */}

        {/* XXX: it's 2006– at VW1 */}
        {/* publishDate */}
        {/* ". " */}

        {/* XXX: actually, use Fluent to localize this and format the date */}
        {/* NOPE: , přístupné on-line: TODO (verze dat TODO, citován stav ze dne ${today}) */}

        {/* TODO: Aktualizováno: … */}

        {`Dostupné z: `}
        <a href={url} target="_blank">{url}</a>
        {". "}

        {`[citováno ${cited}].`}
        </span>

    {/*</LocalizationProvider>*/}</>;
}

const _formatNames = ({
    structuredNames, // Array<any>
    suffixes = null,
    onlyRespType = null,
}) =>
{
    let number = 0;
    const names = [];

    for (let name of structuredNames) {
        number++;

        const respTypeObj = name.responsibleType;
        const respType = (respTypeObj?.type ?? '').toLowerCase();

        if (onlyRespType && respType != onlyRespType)
            continue;

        const firstNames = name.firstName ?? '';
        const lastNames = (name.lastName ?? '').toUpperCase();
        const suffix = name.suffix ?? '';

        let formatted = null;

        if (number == 1) {
            const parts = [lastNames, firstNames].filter(p => p);
            formatted = parts.join(', ');

        } else {
            const parts = [firstNames, lastNames].filter(p => p);
            formatted = parts.join(' ');
        }

        formatted += suffix;

        names.push(formatted);
    }

    let ret = '';

    if (names.length == 0)
        return ret;

    else if (names.length == 1) {
        ret = names[0];

    } else {
        ret = names.slice(0, -1).join(', ');
        ret = `${ret} a ${names[names.length - 1]}`;
    }

    let suffix = '';

    if (suffixes) {
        suffix = suffixes[names.length > 1 ? 'plural' : 'singular'];
        suffix = ` (${suffix})`;
    }

    return ret + suffix;
}

const _addFullStop = (text: string): string =>
{
    return text.match(/.*[.…]$/) ? '' : '.';
}
